import { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { VIEW_MODES } from './ViewModeToggle';

const storageKey = (pageKey) => `viewMode:${pageKey}`;

// Só conveniência do navegador: sem storage, vale o padrão da página.
const readMode = (pageKey) => {
  try {
    const stored = localStorage.getItem(storageKey(pageKey));
    return VIEW_MODES.includes(stored) ? stored : null;
  } catch {
    return null;
  }
};

const writeMode = (pageKey, mode) => {
  try {
    localStorage.setItem(storageKey(pageKey), mode);
  } catch {
    // Storage bloqueado: a escolha vale só nesta visita.
  }
};

/**
 * Grade × cards of a list page, remembered per page in this browser. Below
 * `md` it is always `cards` (they already fit a phone, so the page needs no
 * List fallback) and `canToggle` is false, so the toggle is hidden.
 */
export default function useViewMode(pageKey, defaultMode = 'grid') {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mode, setMode] = useState(() => readMode(pageKey) ?? defaultMode);

  const setViewMode = (next) => {
    setMode(next);
    writeMode(pageKey, next);
  };

  return {
    viewMode: isMobile ? 'cards' : mode,
    setViewMode,
    canToggle: !isMobile,
  };
}
